module.exports = __webpack_public_path__ + "img/mf.220ee011.png";